import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import alyx from './svgs/alyx-standard-popup.svg';
import BgLogins from './svgComponents/BgLogins';

// Optionally can be used as a darkening overlay
const FullPage = styled.div`
  width: 1024px;
  height: 576px;
`;

const Background = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => (width ? `${width}px` : '257px')};
  height: ${({ height }) => (height ? `${height}px` : '60px')};
  border-radius: 67.2px;
  font-family: BentonSans;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  &:disabled {
    box-shadow: none;
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }
`;

// Primary button, in design system
const PurpleButton = styled(Button)`
  border-color: #9c0d63;
  background-color: #9c0d63;
  color: #ffffff;
  &:hover,
  &:focus {
    background-color: #790a4d;
    border-color: #6d0945;
  }
`;

const PopupContainer = styled.div`
  position: absolute;
  left: 177px;
  top: 113px;
`;

const Popup = styled.div`
  width: 670px;
  height: 350px;
  border-radius: 15px;
  background-color: #e7eec5;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ColumnContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 57px;
  left: 259px;
  width: 366px;
  height: 218px;
`;

const Header = styled.div`
  width: 366px;
  max-width: 366px;
  font-family: Quicksand;
  font-size: 34px;
  font-weight: bold;
  color: #573215;
  line-height: 39px;
  margin-bottom: 8px;
`;

const Copy = styled.span`
  width: 366px;
  max-width: 366px;
  font-family: Quicksand;
  font-weight: bold;
  font-size: 25px;
  color: #573215;
  line-height: 39px;
`;
const ButtonContainer = styled.div`
  position: absolute;
  top: 349px;
  left: 185px;
`;

const GoBackButton = styled(PurpleButton)`
  margin-top: -40px;
  font-size: 32px;
`;

const Alyx = styled.div`
  position: relative;
  top: 56px;
  left: 33px;
`;

const refresh = async () => {
  window.location.reload();
};

/*
 * Standard Error message popup with "Go Back" button
 * header - Popup header text
 * message - Popup copy
 * buttonTitle - button title
 * customCallback - custom handling for button
 * children - if popup has children, they are used to render header section
 * children may be needed when header is not plain text only but contains links, etc
*/
const StandardFullPageErrorMessage = ({ header, message, buttonTitle = 'Go Back', customCallback, children }) => (
  <FullPage data-dd-action-name="global-error-page">
    <Background>
      <BgLogins width={1024} height={576} />
      <PopupContainer>
        <Popup>
          <Alyx>
            <img src={alyx} alt="Alyx looking sly" />
          </Alyx>
          <ColumnContainer>
            <Column>
              <Header>{children || header}</Header>
              <Copy>{message}</Copy>
            </Column>
          </ColumnContainer>
          <ButtonContainer>
            <GoBackButton
              width="300"
              height="80"
              onClick={customCallback || refresh}
              data-dd-action-name="global-error-page:recover"
            >
              {buttonTitle}
            </GoBackButton>
          </ButtonContainer>
        </Popup>
      </PopupContainer>
    </Background>
  </FullPage>
);

StandardFullPageErrorMessage.propTypes = {
  header: PropTypes.string,
  message: PropTypes.string,
  buttonTitle: PropTypes.string,
  customCallback: PropTypes.func,
  children: PropTypes.any,
};

StandardFullPageErrorMessage.defaultProps = {
  header: '',
  message: '',
  buttonTitle: 'Go Back',
  customCallback: undefined,
  children: null,
};
export default StandardFullPageErrorMessage;
